import React, { useRef, useState } from "react";
import FileInput from "./FileInput";
import "./GlobalForm.css";
import NestedInput from "./NestedInput";
import NestedInputImage from "./NestedInputImage";
import NestedInputMultiple from "./NestedInputMultiple";
import SelectTag from "./SelectTag";
import TextAreaInput from "./TextAreaInput";
import TextInput from "./TextInput";

const GlobalForm = ({
  data,
  nestedData,
  multiDimensionalData,
  multiDimensionalDataText,
  multiDimensionalDataImage,
  multiDimensionalMultipleData,
  multiDimensionalMultipleDataProject,
  multiDimensionalMultipleDataNoIndex,
  update,
}) => {
  const [newData] = useState(data);

  const formRef = useRef();

  const inputElement = (item, index) => {
    //console.log(item, index, "from inp ele");
    const { elementType } = item;
    if (elementType === "input") {
      return <TextInput key={index} item={item} />;
    } else if (elementType === "textField") {
      return <TextAreaInput key={index} item={item} />;
    } else if (elementType === "file") {
      return <FileInput key={index} item={item} />;
    } else if (elementType === "nested") {
      return <NestedInput key={index} item={item} />;
    } else if (elementType === "nestedText") {
      return <NestedInput key={index} item={item} text={true} />;
    } else if (elementType === "nestedTextService") {
      return <NestedInput key={index} item={item} service={true} />;
    } else if (elementType === "nestedImage") {
      return <NestedInputImage key={index} item={item} />;
    } else if (elementType === "nestedMultiple") {
      return <NestedInputMultiple key={index} item={item} />;
    } else if (elementType === "select") {
      return <SelectTag key={index} item={item} />;
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const submitData = {};
    data.map(
      (item) =>
        (submitData[item.name] = formRef.current[item.name]?.value
          ? formRef.current[item.name]?.value
          : formRef.current[item.name]?.src)
    );

    nestedData &&
      nestedData.map((item) => {
        const temp = [];
        formRef.current[item.name]?.length
          ? formRef.current[item.name].forEach((element) => {
              temp.push(element.value ? element?.value : element?.src);
            })
          : formRef.current[item.name]?.value &&
            temp.push(formRef.current[item.name].value);
        submitData[item.name] = temp;
      });

    multiDimensionalData &&
      multiDimensionalData.map((item) => {
        const temp = [];
        formRef.current[item.name]?.length > 0
          ? formRef.current[item.name].forEach((element) => {
              temp.push([
                element?.parentNode?.children[0]?.value,
                element?.value,
              ]);
            })
          : temp.push([
              formRef.current[item.name]?.parentNode?.children[0]?.value,
              formRef.current[item.name]?.value,
            ]);

        submitData[item.name] = temp;
      });

    multiDimensionalDataText &&
      multiDimensionalDataText.map((item) => {
        const temp = [];

        formRef.current[item.name].length
          ? formRef.current[item.name].forEach((element) => {
              temp.push([
                element?.parentNode?.children[0]?.value,
                element?.value,
              ]);
            })
          : temp.push([
              formRef.current[item.name]?.parentNode?.children[0]?.value,
              formRef.current[item.name]?.value,
            ]);
        submitData[item.name] = temp;
      });

    multiDimensionalDataImage &&
      multiDimensionalDataImage.map((item) => {
        const temp = [];
        const tempImage = [];
        const tempText = [];

        formRef.current[item.name]?.length
          ? formRef.current[item.name].forEach((element) => {
              const image = element?.parentNode?.children[1]?.src;
              const imageText = element?.value;

              if (image) {
                tempImage.push(image);
              }
              if (imageText) {
                tempText.push(imageText);
              }
            })
          : temp.push({
              url: formRef.current[item.name]?.parentNode?.children[1]?.src,
              title: formRef.current[item.name]?.value,
            });

        for (let i = 0; i < tempText.length; i++) {
          temp.push({
            url: tempImage[i],
            title: tempText[i],
          });
        }
        submitData[item.name] = temp;
      });

    // no index
    multiDimensionalMultipleDataNoIndex &&
      multiDimensionalMultipleDataNoIndex.map((item) => {
        let descData = [];
        const desVal = formRef?.current[item.name];

        console.log(formRef.current[item.name]?.length);
        for (let i = 0; i < desVal?.length; i++) {
          descData.push({
            title: desVal[i]?.value,
            description: desVal[i + 1]?.value,
          });
          i = i + 1;
        }
        if (descData.length) {
          submitData[item.name] = descData;
        } else {
          submitData[item.name] = [];
        }
      });

    // for 3 values
    multiDimensionalMultipleDataProject &&
      multiDimensionalMultipleDataProject.map((item) => {
        let descData = [];
        const desVal = formRef?.current[item.name];

        console.log(formRef.current[item.name]?.length);
        for (let i = 0; i < desVal?.length; i++) {
          descData.push({
            index: desVal[i]?.value,
            title: desVal[i + 1]?.value,
            paragraph: desVal[i + 2]?.value,
          });
          i = i + 2;
        }
        if (descData.length) {
          submitData[item.name] = descData;
        } else {
          submitData[item.name] = [];
        }
      });

    // for 5 values
    multiDimensionalMultipleData &&
      multiDimensionalMultipleData.map((item) => {
        let descData = [];
        const desVal = formRef?.current[item.name];

        for (let i = 0; i < desVal?.length; i++) {
          descData.push({
            index: desVal[i]?.value,
            title: desVal[i + 1]?.value,
            paragraph: desVal[i + 2]?.value,
            imgTitle: desVal[i + 3]?.value,
            image: desVal[i + 4]?.src,
          });
          i = i + 4;
        }
        if (descData.length) {
          submitData[item.name] = descData;
        } else {
          submitData[item.name] = [];
        }
      });

    update(submitData);
  };

  return (
    <div className="container mx-auto lg:pt-24 py-10 px-5 lg:px-16 ">
      <form ref={formRef} onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 justify-items-center gap-8 pb-8">
          {newData.map((item, index) => inputElement(item, index))}
        </div>

        <div className="flex justify-center ">
          <button type="submit" className="btn btnW7ide hover:bg-gray-100">
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default GlobalForm;
